import type { DiscoverCollectionApi } from 'api-typings/users/users';
import type { DiscoverCollection } from './discover-collections.model';

export function transformDiscoverCollection(
  collection: DiscoverCollectionApi,
): DiscoverCollection {
  return {
    id: collection.id,
    name: collection.name,
    description: collection.description,
    ownerId: collection.owner_id,
    dateCreated: collection.date_created * 1000,
    lastUpdated: collection.last_updated * 1000,
    isPrivate: collection.is_private,
    isDeleted: collection.is_deleted,
    type: collection.collection_type,
    previewItems: collection.preview_items ? collection.preview_items : [],
    itemCount: collection.count ?? 0,
    seoUrl: `${encodeURIComponent(
      collection.name.split(' ').join('-').toLowerCase(),
    )}_${collection.id}`,
  };
}
